module.exports = __webpack_public_path__ + "static/icon-flexible.c7692efe.png";


//////////////////
// WEBPACK FOOTER
// ./app/resource/page/index/views/festival/icon-flexible.png
// module id = 273
// module chunks = 2